import React, { useState, useEffect, useContext } from "react";
import { Breadcrumb, Col, message, notification, Row, Typography } from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import { translate } from "../../../locale";
import CompanyServices from "../../../services/CompanyServices";
import DashServices from "../../../services/DashServices";
import SecondaryButton from "../../../components/Buttons/SecondaryButton";
import CardInfo from "../../../components/Cards/CardInfo";
import PieCompanyActivePatients from "../../../components/Charts/PieCompanyActivePatients";
import PieEnrolledUsers from "../../../components/Charts/PieEnrolledUsers";
import FullPageLoader from "../../../components/Loaders/FullPageLoader";
import AdministratorUsers from "../../../components/Tables/AdministratorUsers";
import AddAdministrator from "../../../components/Modals/AddAdministrator";
import { AdminContext } from "../../../providers/AdminContext";
import InviteUser from "../../../components/Modals/InviteUser";
import FormExternalLink from "./FormExternalLink";
import CoordinatorUsers from "../../../components/Tables/CoordinatorUsers";
import CompanyProfessionals from "../../../components/Tables/CompanyProfessionals";

import { Button, Tooltip } from "antd";
import SendEmail from "../../../components/Modals/SendEmail";
import SendNotification from "../../../components/Modals/SendNotification";

const { Title } = Typography;

const CompanyDetails = () => {
  const [loading, setLoading] = useState(false);
  const [modalAddAdmin, setModalAddAdmin] = useState(false);
  const [company, setCompany] = useState(null);
  const [subscriptions, setSubscriptions] = useState(null);
  const navigate = useNavigate();
  const { user } = useContext(AdminContext);
  const [isSuper, setIsSuper] = useState(false);
  const [isSuperOrAdmin, setIsSuperOrAdmin] = useState(false);
  const [modalInviteAdmin, setModalInviteAdmin] = useState(false);
  const [reloadAdmin, setReloadAdmin] = useState(0);

  const { id } = useParams();

  useEffect(() => {
    loadCompanies();
    loadSubscriptions();
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user !== null && user !== undefined) {
      setIsSuper(user.user.rol === "eira-super-admin");
      setIsSuperOrAdmin(
        user.user.rol === "eira-company-admin" ||
          user.user.rol === "eira-super-admin"
      );
    }
  }, [user]);

  const loadCompanies = async () => {
    setLoading(true);
    try {
      const res = await CompanyServices.getCompany(id);

      if (res.status >= 200 && res.status < 300) {
        setCompany(res.data.enterprises);
      } else if (res.status === 400) {
        message.error(translate(res.data.message));
        navigate("/admin/companies");
        return;
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const loadSubscriptions = async () => {
    setLoading(true);
    try {
      const res = await CompanyServices.getSubscriptions(id);
      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data.subscriptions.length > 0
      ) {
        setSubscriptions(res.data.subscriptions);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleAddSubscription = () => {
    navigate("/admin/subscriptions/add/" + id, { state: { enterprise: id } });
  };

  const handleEditSubscription = (sub_id) => {
    navigate("/admin/subscriptions/" + sub_id, { state: { enterprise: id } });
  };

  const handleClickActivePatients = (data) => {
    if (data.type === "Inactivos" || data.type === "Inactives") {
      navigate(`/admin/users/inactives/${id}`);
    }
  };
  const handleClickEnrolledUsers = (data) => {
    if (
      data.type === "Pendientes" ||
      data.type === "Pendings" ||
      data.type === "No aceptados"
    ) {
      navigate(`/admin/requests/pendings/${id}`, {
        state: { company: company },
      });
    }
  };
  const handleInviteAdmin = () => {
    setModalInviteAdmin(true);
  };
  const handleCancelInviteAdmin = () => {
    setModalInviteAdmin(false);
  };
  const handleCompleteInviteAdmin = (data) => {
    setModalInviteAdmin(false);
  };
  const handleChangeRole = () => {
    setReloadAdmin(reloadAdmin + 1);
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/admin/companies">{translate("Empresas")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {company !== null && company.name}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Empresa")} {company !== null && company.name}
          </Title>
        </Col>
        <Col span="24" className="mt-8">
          <div className="flex flex-row items-stretch space-x-20">
            <div className="flex-1">
              <Title level={5} className="text-center">
                Usuarios invitados
              </Title>
              <div className="flex justify-center">
                <div className="w-8/12">
                  <PieEnrolledUsers
                    loadingParent={company === null || subscriptions === null}
                    selectedData={{
                      period: null,
                      suscription: null,
                    }}
                    onClick={handleClickEnrolledUsers}
                  />
                </div>
              </div>
            </div>
            <div className="flex-1">
              <Title level={5} className="text-center">
                Usuarios Activos (mes en curso)
              </Title>
              <div className="flex justify-center">
                <div className="w-8/12">
                  <PieCompanyActivePatients
                    loadingParent={company === null || subscriptions === null}
                    selectedData={{
                      period: 30,
                      suscription: "",
                      enterprise: id,
                    }}
                    onClick={handleClickActivePatients}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Suscripciones")}
            </Title>
          </div>
          <Row gutter={[16, 16]}>
            <Col span="24">
              <SecondaryButton
                onClick={() => handleAddSubscription()}
                className="mb-4 hover:border-custom_primary hover:text-custom_primary"
                disabled={!isSuperOrAdmin}
              >
                {translate("Nueva suscripción")}
              </SecondaryButton>
            </Col>
            {subscriptions !== null &&
              subscriptions.map((item, key) => (
                <Col span="6" key={key}>
                  <CardInfo
                    showIcon={true}
                    onClickIcon={() => handleEditSubscription(item.id)}
                    title={item.name}
                    selected={true}
                  />
                </Col>
              ))}
          </Row>
          <div className="flex flex-col justify-center items-center w-full my-8 bg-gray-200">
            <Title level={4} className="my-4 uppercase">
              {translate("Administradores")}
            </Title>
          </div>

          <Row gutter={16}>
            {isSuper && (
              <Col span={12}>
                <SecondaryButton
                  onClick={handleInviteAdmin}
                  className="mb-4 hover:border-custom_primary hover:text-custom_primary"
                  disabled={!isSuperOrAdmin}
                >
                  {translate("Invitar administrador")}
                </SecondaryButton>
                <InviteUser
                  subscriptionId={""}
                  visible={modalInviteAdmin}
                  onCancel={handleCancelInviteAdmin}
                  onComplete={handleCompleteInviteAdmin}
                  rol={"company-admin"}
                  enterpriseId={id}
                />
              </Col>
            )}
            <Col span="24 mt-4">
              <AdministratorUsers
                reload={reloadAdmin}
                onChange={handleChangeRole}
                subscriptions={subscriptions}
                enterpriseId={id}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      {loading && <FullPageLoader />}
    </div>
  );
};
export default CompanyDetails;
